function TreatmentMeedyVO(id, outpatientBeginDate, outpatientEndDate, ward, pharmacologically, outpatientSurgery, rehabilitation,
                     rehabilitationBeginDate, rehabilitationEndDate, rehabilitationAddress, other, otherDescription,
                     hospitalSurgery, hospitalSurgeryDescription, hospitalBeginDate, hospitalEndDate, conservative,
                     outpatient, hospital) {

  this.id = id;
  this.outpatient = outpatient;
  this.outpatientBeginDate = outpatientBeginDate;
  this.outpatientEndDate = outpatientEndDate;
  this.ward = ward;
  this.pharmacologically = pharmacologically == true;
  this.outpatientSurgery = outpatientSurgery == true;
  this.rehabilitation = rehabilitation == true;
  this.rehabilitationBeginDate = rehabilitationBeginDate;
  this.rehabilitationEndDate = rehabilitationEndDate;
  this.rehabilitationAddress = rehabilitationAddress;
  this.other = other;
  this.otherDescription = otherDescription;
  this.hospitalSurgery = hospitalSurgery;
  this.hospitalSurgeryDescription = hospitalSurgeryDescription;
  this.hospitalBeginDate = hospitalBeginDate;
  this.hospitalEndDate = hospitalEndDate;
  this.conservative = conservative;
  this.hospital = hospital;

  var _typeContext = {
    beginDate : Date,
    endDate : Date,
    rehabilitationBeginDate : Date,
    rehabilitationEndDate : Date
  };

  this._getType = function (property) {
    if (_typeContext.hasOwnProperty(property)) {
      return _typeContext[property];
    }
    else {
      return undefined;
    }
  };

  var _mappingContext = {};

  this._getMapping = function (property) {
    if (_mappingContext[property]) {
      return _mappingContext[property];
    }
    else {
      return undefined;
    }
  };
}
